export const UPDATE_GROUPS = 'UPDATE_GROUPS';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const UNSET_GROUP = 'UNSET_GROUP';
